import { Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faUsers, faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ReportService } from 'src/app/services/report.service';
import { Subject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { AutoSaveComponent } from '../auto-save/auto-save.component';

@Component({
    selector: 'app-team-supporting',
    templateUrl: './team-supporting.component.html',
    styleUrls: ['./team-supporting.component.scss'],
    standalone: false
})


export class TeamSupportingComponent extends AutoSaveComponent implements OnChanges, OnInit {

  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;
  faUsers = faUsers;

  report = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
    @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  forests: string[] = []
  saveSubject = new Subject<any>();
  optional = input(false);
  page = input("7");

  pageLoaded = false;

  forestContacts: any[] = [];

  users = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'name',
    'role',
    'skills'
  ];

  reg = APP_CONSTANTS.URL_REGEX;

  form = this.formBuilder.group({
    supporting_documents: ["", [Validators.pattern(this.reg), Validators.maxLength(500)]],
    recommendations_map: ["", [Validators.pattern(this.reg), Validators.maxLength(500)]],
    burn_severity_map: ["", [Validators.pattern(this.reg), Validators.maxLength(500)]],
    kmz_submittal_package: ["", [Validators.pattern(this.reg), Validators.maxLength(500)]],
    otherLinks: this.formBuilder.array([]),
  });
  get otherLinks() {
    return this.form.get("otherLinks") as FormArray;
  }

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    private readonly userService: UserService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    super()
  }

  loadUsers() {
    this.users.data = this.report().users;
    this.userService.getUserList("", ["baer_roles.baer_role"]).subscribe(data => {
      data.users.forEach((user: any) => {
        // 4- Forest BAER Coordinator
        // 5-Forest BAR Coordinator
        user.isFOCO = user.baer_roles.filter((obj: any) => [4, 5].includes(obj.baer_role.value))?.map((x: any) => x.forest_name ?? user.forest_name) ?? [];
        if (!user.isFOCO) return
        user.isFOCO.forEach((forestRole: any) => {
          if (this.forests.includes(forestRole)) {
            this.forestContacts.push(user);
          }
        })
      })
      this.pageLoaded = true;
    })
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    this.forests = this.report().assessment.forest_name.split(",")
    this.loadUsers();
    this.report().supporting_files?.filter(
      (file: any) => file.question == "Other Links"
    ).forEach((file: any) => {
      this.otherLinks.push(this.formBuilder.group({
        file_name: file.file_name,
        link: [file.file_link, [Validators.pattern(this.reg), Validators.maxLength(500)]],
        supporting_files_id: file.supporting_files_id
      }))
    })
    if (this.otherLinks.length == 0) {
      this.addFileLink();
    }
    this.form.patchValue({
      supporting_documents: decodeURI(this.report().supporting_documents ?? ""),
      recommendations_map: decodeURI(this.report().recommendations_map ?? ""),
      burn_severity_map: decodeURI(this.report().burn_severity_map ?? ""),
      kmz_submittal_package: decodeURI(this.report().kmz_submittal_package ?? ""),
    })
    this.listenForChanges(this.form);
    this.formReady = true;
    this.loaded.emit(true);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    this.save(true);
  }

  route() {
    this.save()
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: + this.page()+1 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page()-1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  getSupportingFiles(): any[] {
    let supportingFiles = []

    for (const element of this.otherLinks.controls) {
      let control = element.value
      if (control.link == "") continue
      if (element.invalid) continue
      let file = {
        supporting_files_id: control.supporting_files_id != -1 ? control.supporting_files_id : undefined,
        file_name: control.file_name == "" ? "Untitled" : control.file_name,
        file_link: control.link,
        section: 7,
        question: "Other Links",
        report_id: this.report().report_id,
      }
      if (file.supporting_files_id) {
        supportingFiles.push(file)
      } else {
        this.reportService.uploadFile(file).subscribe({
        next: (response) => {
          element.patchValue(element.patchValue({
            supporting_files_id: response.supporting_files_id
          }))
        },
        error: (response) => {
          this.toast.openErrorSnackBar(`There was an error uploading file`, "Please try again.");
          console.log("err", response)
        }
      })
      }

    }
    return supportingFiles
  }

  gatherData(): any {
    let supportingFiles = this.getSupportingFiles()

    let data: any = {
      report_id: this.report().report_id,
      supporting_files: supportingFiles,
      [`page_${this.page()}_status_id`]: 2,
    }
    let allFieldsFilled = true

    let linkFields = ["supporting_documents", "recommendations_map", "burn_severity_map", "kmz_submittal_package"]

    // Encode link fields to URI and check for form complete
    for (let field in this.form.controls) {
      if (!linkFields.includes(field)) continue
      if (this.form.get(field)?.value === null || this.form.get(field)?.value === "") {
        if (!this.optional()) allFieldsFilled = false
      }
      if (this.form.get(field)?.invalid) {
        allFieldsFilled = false
        data[field] = null
      } else
        data[field] = encodeURI(this.form.get(field)?.value)
    }
    if (this.optional()) allFieldsFilled = true

    if (!allFieldsFilled) {
      data[`page_${this.page()}_status_id`] = 1
    }
    data.allFieldsFilled = allFieldsFilled;
    return data
  }

  override save(navigate?: boolean) {
    this.navDebounceCheck(navigate)

    if (!this.form.dirty && 
      !(!this.report()[`page_${this.page()}_status_id`] && this.optional())
    ) {
      if (navigate) {
        this.route()
      }
      // Don't save if nothing has changed on autosave
      return
    }

    let data = this.gatherData()

    if (!navigate && this.checkIfNotNeedToSave(data)) return

    this.saveSubject.next(null);
    this.status.emit(data.allFieldsFilled ? 2 : 1);

    this.reportService.updateReport(data).subscribe({
      next: (response) => {
        if (navigate) {
          if (this.nav() == "forward" && !data.allFieldsFilled) {
            this.form.markAllAsTouched();
            this.errorList = [];
            for (let field in this.form.controls) {
              const control = this.form.get(field);
              if (control?.invalid) {
                this.errorList.push(field.replaceAll('_', ' '));
              }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.nav.set('');
            this.postSave();
          } else
            this.route() // navigate route after save because next page needs to see this page's changes
        } else {
          this.postSave()
        }
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
    })
  }

  addFileLink() {
    this.otherLinks.push(this.formBuilder.group({
      file_name: "",
      link: ["", [Validators.pattern(this.reg), Validators.maxLength(500)]],
      supporting_files_id: -1,
    }))
  }

  removeFileLink(index: number) {
    if (this.otherLinks.controls[index].value.supporting_files_id == -1) {
      this.otherLinks.removeAt(index) // file link not in database yet, no need for api call
      return
    }
    let control = this.otherLinks.controls[index]
    this.reportService.deleteFile(control.value.supporting_files_id).subscribe({
      next: (response) => {
      },
      error: (response) => {
        this.otherLinks.insert(index, control) // re-add file link row to show delete was unsuccessful
        console.log("err", response)
      }
    })
    this.otherLinks.removeAt(index)

  }
}
